import React, { useEffect, useState } from "react";
import { api, Modal } from "../../../../services/common";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import "./ViewSchedule.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  TextField,
  Box,
  List, ListItem, ListItemText, ListItemIcon, Checkbox, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import { ToastContainer, toast } from "../../../../services/common";

const ViewSchedule = () => {
  const [schedule, setSchedule] = useState([]);
  const [createModal, setCreateModal] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const selectedSlotId = null; // When Selecting for Rescheduling
  const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
  const [startDate, setStartDate] = useState(today);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [endDate, setEndDate] = useState(today);
  const [cancelReason, setCancelReason] = useState("");
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  let id = localStorage.getItem('uid');
  const [tutors, setTutors] = useState([]);
  const [selectedTutor, setSelectedTutor] = useState('');
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
  const [selectedClass, setSelectedClass] = useState(null);
  const [demo, setDemo] = useState(false)
  const [tutorId, setTutorId] = useState(null);
  const [webinar, setWebinar] = useState(false); // For Webinar Type
  const [dontSendReminder, setDontSendReminder] = useState(false);
  const [newClass, setNewClass] = useState({
    course: '',
    start_time: dayjs(new Date()).add(10, 'minute'),
    batch_limit: 5, // Default batch limit
    students: [],
    demo: false,
    webinar: false,
    dontSendReminder: false,
    end_time: dayjs(new Date()).add(70, 'minute'),
  });

  const handleWebinarChange = (e) => {
    setWebinar(prevState => !prevState)
    setNewClass(prevClass => ({ ...prevClass, webinar: !webinar }))
  }

  const handleReminderChange = (e) => {
    setDontSendReminder(prevState => !prevState)
    setNewClass(prevClass => ({ ...prevClass, dontSendReminder: !dontSendReminder }))
  }


  const formatCustomDate = (dateString, timeZone = 'Asia/Kolkata') => {
    const date = new Date(dateString);
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    const options = {
      timeZone, weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    if (date.toDateString() === now.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday ';
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return 'Tomorrow ';
    } else {
      return date.toLocaleString(undefined, options);
    }
  }

  const changeDate = (date) => {
    setLoading(true);
    setSelectedDate(date);
    const params = {
      date: date
    };
    api.get("/tutors/view-schedule/" + id, { params }).then((response) => {
      const temp = [...response.data];
      setSchedule(temp);
      setLoading(false);
      response.data.forEach((res) => {
        res.startTime = new Date(res.start_time).toLocaleString(undefined, { timeZone: 'Asia/Kolkata', hour12: true, hour: 'numeric', minute: 'numeric' });
        res.endTime = new Date(res.end_time).toLocaleString(undefined, { timeZone: 'Asia/Kolkata', hour12: true, hour: 'numeric', minute: 'numeric' });
        res.date = formatCustomDate(res.date);
      }
      )
    })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || error.message);
      });
  }

  const cancelClass = (type) => {
    setLoading(true);
    const body = {
      slotId: selectedClassId,
      cancel_reason: cancelReason
    };

    api.delete("/tutors/cancel-schedule/" + tutorId, { data: body }).then((response) => {
      setLoading(false);
      setCancelModal(false);
      fetchSchedule();
      toast.success("Class Cancelled Successfully");
    })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || error.message);
      });
  };


  const scheduleClass = () => {
    setLoading(true);
    let body = {
      start_time: newClass.start_time,
      end_time: newClass.end_time,
      students: newClass?.students,
      course: newClass?.course,
      demo: newClass?.demo,
      batch_limit: Number(newClass?.batch_limit),
      webinar: newClass?.webinar,
      dontSendReminder: newClass?.dontSendReminder
    }
    api.post("/tutors/add-schedule/" + selectedTutor, body).then((response) => {
      setLoading(false);
      toast.success("Class Scheduled Successfully");
      setCreateModal(false);
    })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || error.message);
        setCreateModal(false);
      });
  }

   const fetchTutors = async () => {
          try {
              const res = await api.get(`/tutors/view-tutors`);
              setTutors(res.data || []);
          } catch (error) {
              console.error("Error fetching tutors:", error);
          }
      };

  const handleStudentChange = (studentId) => () => {
    const currentIndex = newClass.students.indexOf(studentId);
    const newChecked = [...newClass.students];

    if (currentIndex === -1) {
      newChecked.push(studentId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setNewClass((prevNewClass) => ({
      ...prevNewClass,
      students: newChecked,
    }));
  };

  const fetchTutorDetails = async (tutorId) => {
    const res = await api.get(`tutors/view-tutor/${tutorId}`);
    setUser(res.data); 
  };


  const updateClass = () => {
    setLoading(true);
    let body = {
      slotId: selectedClass?.id,
      students: selectedClass?.students,
      course: selectedClass?.course,
      start_time: selectedClass?.start_time,
      end_time: selectedClass?.end_time,
      demo: selectedClass?.demo,
      batch_limit: Number(selectedClass?.batch_limit),
      webinar: selectedClass?.webinar,
      dontSendReminder: selectedClass?.dontSendReminder
    }
    api.put("/tutors/update-schedule/" + selectedTutor, body).then((response) => {
      setLoading(false);
      toast.success("Class Updated Successfully");
      changeDate(selectedDate)
      setRescheduleModal(false)
    })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message || error.message);
      });
  }

  const handleStudentChangeReschedule = (studentId) => () => {
    const currentIndex = selectedClass.students.indexOf(studentId);
    const newChecked = [...selectedClass.students];

    if (currentIndex === -1) {
      newChecked.push(studentId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedClass((prevNewClass) => ({
      ...prevNewClass,
      students: newChecked,
    }));
  };

  const handleDemoChange = (e) => {
    setDemo(prevState => !prevState)
    setNewClass(prevClass => ({ ...prevClass, demo: !demo }))
  }


  const handleUpdateClass = (entry) => {

    console.log("Selected Entry for Update:", entry);


    // Convert start_time and end_time to dayjs objects
    setSelectedClass({
      id: entry.id,
      course: entry.course?.id || '',
      start_time: dayjs(entry.start_time),
      end_time: dayjs(entry.end_time),
      batch_limit: entry.batch_limit,
      students: entry.students,
      demo: entry.demo || false,
      webinar: entry.webinar || false,
      dontSendReminder: entry.dontSendReminder || false
    });
    setRescheduleModal(true);
  };

  const fetchSchedule = async () => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const response = await api.get(`/common/view-schedule`, { params });
      setSchedule(response.data);
    } catch (error) {
      console.error("Error fetching schedule:", error);
    }
  };

  const handleOpenModal = (students, id, tutorId) => {
    setSelectedStudents(students || []);
    setOpenModal(true);
    setSelectedClassId(id);
    setTutorId(tutorId);
   
  };

  const showCancelModal = (id, tutorId) => {
    setSelectedClassId(id);
    setCancelModal(true);
    setTutorId(tutorId);
  }

  const handleCloseModal
    = () => {
      setOpenModal(false);
      setSelectedStudents([]);
    };


  const handleRemindStudent = async (studentId) => {
    try {
      await api.post(`/students/send-reminder`, { studentId, eventId: selectedClassId, tutorId: tutorId  });
      alert("Reminder sent!");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSchedule();
    fetchTutors();
  }, []);

  return (
    <div>
      {/* Header with Filters */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h5">Scheduled Classes</Typography>
        <Button variant="contained" onClick={() => setCreateModal(true)}>
          Add Schedule
        </Button>
      </Box>

      <Box display="flex" gap={2} mb={2}>
        <TextField
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <TextField
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <Button variant="outlined" onClick={fetchSchedule}>
          Filter
        </Button>
      </Box>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 800 }} aria-label="schedule table">
          <TableHead>
            <TableRow>
              <TableCell>Tutor Name</TableCell>
              <TableCell>Tutor Phone</TableCell>
              <TableCell>Class Type</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Students</TableCell>
              <TableCell>Link</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schedule.length > 0 ? (
              schedule.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>{entry.tutorName}</TableCell>
                  <TableCell>{entry.phone || "--"}</TableCell>
                  <TableCell>{entry.demo ? "Demo" : "Normal"}</TableCell>
                  <TableCell>
                    {entry.date
                      ? new Date(entry.date).toLocaleDateString()
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {entry.start_time
                      ? new Date(entry.start_time).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                      : "--"}{" "}
                    -{" "}
                    {entry.end_time
                      ? new Date(entry.end_time).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                      : "--"}
                  </TableCell>
                  <TableCell>
                    <span
                      style={{ cursor: "pointer", color: "blue" }}
                      onClick={() => handleOpenModal(entry.students, entry.id, entry.tutorId)}
                    >
                      {entry.students?.length || 0}
                    </span>
                  </TableCell>
                  <TableCell>
                    {entry.link ? (
                      <a
                        href={entry.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Join
                      </a>
                    ) : (
                      "--"
                    )}
                  </TableCell>
                  <TableCell>
                    {/* <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handleUpdateClass(entry)}
                    >
                      Update
                    </Button> */}

                    <Button size="small" variant="outlined" onClick={() => showCancelModal(entry.id, entry.tutorId)}>Cancel </Button>

                  </TableCell>


                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No schedule available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* View Students Modal */}
      <Modal show={openModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>Student Details</Modal.Header>
        <Modal.Body>
          <div className="attendee-list">
          {selectedStudents.length > 0 ? (
            selectedStudents.map((student, index) => (
              <Box key={index} mb={2} class="flex space-between">
                <div> {index+1}. {student.name || "--"}</div>
                <div> {student.phone || "--"}</div>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ mt: 0.5 }}
                  onClick={() => handleRemindStudent(student.id )}
                >
                  Remind
                </Button>
              </Box>
            
            ))
          ) : (
            <div>No students found.</div>
          )}
            </div>
        </Modal.Body>
      </Modal>


      <Modal show={createModal} onHide={() => setCreateModal(false)} dialogClassName="modal-25w">
        <Modal.Header closeButton>
          <b className="cancel-heading">Create New Class</b>
        </Modal.Header>
        <Modal.Body>
          <form >

          <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
  <InputLabel id="tutor-select-label">Select Tutor</InputLabel>
  <Select
    labelId="tutor-select-label"
    value={selectedTutor}
    onChange={(e) => {
      console.log("Selected Tutor ID:", e.target.value);
      setSelectedTutor(e.target.value);
      fetchTutorDetails(e.target.value); // fetch students + courses
    }}
  >
    {tutors.map(tutor => (
      <MenuItem key={tutor.id} value={tutor.id}>
        {tutor.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="course-select-label" className="create-class-label"> Select Course</InputLabel>
              <Select
                labelId="course-select-label"
                id="course-select"
                value={newClass.course}
                onChange={(e) => setNewClass(prevClass => ({ ...prevClass, course: e.target.value }))}
                label="Course"
              >
                {user && user.courses && user?.courses.map((course) => (
                  <MenuItem key={course?.id} value={course?.id}>
                    {course.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="calendar-container-class">
              <span className="create-class-label select-date">
                Select Date
              </span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DateCalendar', 'DateCalendar']}>
                  <DemoItem >
                    <DateCalendar value={newClass.date} onChange={(newDate) =>
                      setNewClass(prev => {
                        const updatedStart = dayjs(newDate)
                          .hour(dayjs(prev.start_time).hour())
                          .minute(dayjs(prev.start_time).minute());

                        const updatedEnd = dayjs(newDate)
                          .hour(dayjs(prev.end_time).hour())
                          .minute(dayjs(prev.end_time).minute());

                        return {
                          ...prev,
                          start_time: updatedStart,
                          end_time: updatedEnd,
                        };
                      })
                    } />
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>
            </div>
            <div className="row">
              <div className="col-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['TimePicker', 'TimePicker']}>

                    <TimePicker
                      className="create-class-label" label="Start Time"
                      value={newClass.start_time}
                      onChange={(date) => setNewClass(prevClass => ({ ...prevClass, start_time: date }))}
                    />

                  </DemoContainer>
                </LocalizationProvider>
              </div>

              <div className="col-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['TimePicker', 'TimePicker']}>

                    <TimePicker
                      className="create-class-label" label="End Time"
                      value={newClass.end_time}
                      onChange={(date) => setNewClass(prevClass => ({ ...prevClass, end_time: date }))}
                    />

                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </div>

            <div class="row">

              <div className="col-6 mobile">
                <div className="batch-limit-label">
                  Batch Limit
                </div>
                <input className="batch-limit" type="number" min={1} max={10} value={newClass.batch_limit} onChange={(e) => setNewClass(prevClass => ({ ...prevClass, batch_limit: e.target.value }))} />
              </div>


              <div className="col-3 mobile">
                <div className="batch-limit-label demo-checkbox">
                  Demo Class   {newClass?.demo}
                </div>
                <Checkbox
                  checked={demo}
                  onClick={handleDemoChange}
                  inputProps={{ 'aria-label': 'controlled' }}
                />

              </div>



              <div className="col-3 mobile">
                <div className="batch-limit-label demo-checkbox">
                  Webinar   {newClass?.webinar}
                </div>

                <Checkbox
                  checked={webinar}
                  onClick={handleWebinarChange}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </div>

              <div className="col-3 mobile">
                <div className="batch-limit-label demo-checkbox">
                  Dont Send Whatsapp   {newClass?.dontSendReminder}
                </div>
                <Checkbox
                  checked={dontSendReminder}
                  onClick={handleReminderChange}
                  inputProps={{ 'aria-label': 'controlled' }}
                />

              </div>

            </div>

            <div className="create-class-label select-students">Students</div>
            <List className="student-list">
              {user && user.students && user?.students.map((student) => (
                <ListItem key={student.id} onClick={handleStudentChange(student.id)}>
                  <ListItemIcon className="student-checkbox">
                    <Checkbox
                      edge="start"
                      checked={newClass.students.indexOf(student.id) !== -1}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ 'aria-labelledby': `checkbox-list-label-${student.id}` }}
                    />
                  </ListItemIcon>
                  <ListItemText className="student-items" id={`checkbox-list-label-${student.id}`} primary={student.name} />
                </ListItem>
              ))}
            </List>


            <div className="flex">
              <Button className="cancel-class cancel-button" onClick={() => setCreateModal(false)}>
                Cancel
              </Button>
              <Button className="join-class save-button" onClick={() => scheduleClass()} variant="contained" >
                Save
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={rescheduleModal} onHide={() => setRescheduleModal(false)} dialogClassName="modal-25w">
        <Modal.Header closeButton>
          <b className="course-time"> {selectedClass?.date}  | {selectedClass?.start_time} - {selectedClass?.end_time}</b>
        </Modal.Header>
        <Modal.Body>
          <Select
            labelId="course-select-label"
            id="course-select"
            value={selectedClass?.course}
            onChange={(e) => setSelectedClass(prevClass => ({ ...prevClass, course: e.target.value }))}
            label="Course"
          >
            {user && user.courses && user?.courses.map((course) => (
              <MenuItem key={course?.id} value={course?.id}>
                {course.name}
              </MenuItem>
            ))}
          </Select>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateCalendar', 'DateCalendar']}>
              <DemoItem >
                <DateCalendar value={dayjs(selectedClass?.start_time)} onChange={(newDate) =>
                  setSelectedClass(prev => {
                    const updatedStart = dayjs(newDate)
                      .hour(dayjs(prev.start_time).hour())
                      .minute(dayjs(prev.start_time).minute())

                    const updatedEnd = dayjs(newDate)
                      .hour(dayjs(prev.end_time).hour())
                      .minute(dayjs(prev.end_time).minute())

                    return {
                      ...prev,
                      start_time: new Date(updatedStart.$d).toISOString(),
                      end_time: new Date(updatedEnd.$d).toISOString(),
                    };
                  })} />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider>
          <div className="row">
            <div className="col-6"
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['TimePicker', 'TimePicker']}>
                  <TimePicker
                    className="create-class-label" label="Select Time"
                    value={dayjs(selectedClass?.start_time)}
                    onChange={(time) => setSelectedClass(prevClass => {
                      const date = new Date(time.$d).toISOString();
                      return { ...prevClass, start_time: date }
                    }
                    )}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>

            <div className="col-6"
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['TimePicker', 'TimePicker']}>
                  <TimePicker
                    className="create-class-label" label="Select Time"
                    value={dayjs(selectedClass?.end_time)}
                    onChange={(time) => setSelectedClass(prevClass => {
                      const date = new Date(time.$d).toISOString();
                      console.log("Selected End Time:", date);
                      return { ...prevClass, end_time: date }
                    }
                    )}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="batch-limit-label">
                Batch Limit
              </div>
              <input className="batch-limit" type="number" min={1} max={10} value={selectedClass?.batch_limit} onChange={(e) => setSelectedClass(prevClass => ({ ...prevClass, batch_limit: e.target.value }))} />
            </div>
            <div className="col-3">
              <div className="batch-limit-label">
                Demo Class
              </div>
              <Checkbox
                checked={selectedClass?.demo}
                onChange={(e) => setSelectedClass(prevClass => ({ ...prevClass, demo: e.target.checked }))}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </div>

            <div className="col-3">
              <div className="batch-limit-label">
                Webinar
              </div>
              <Checkbox
                checked={selectedClass?.webinar}
                onChange={(e) => setSelectedClass(prevClass => ({ ...prevClass, webinar: e.target.checked }))}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </div>


            <div className="col-3">
              <div className="batch-limit-label">
              Dont Send Reminder
              </div>
              <Checkbox
                checked={selectedClass?.dontSendReminder}
                onChange={(e) => setSelectedClass(prevClass => ({ ...prevClass, dontSendReminder: e.target.checked }))}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </div>



          </div>
          <div>
            <div className="create-class-label select-students">Students</div>
            <List className="student-list">
              {user && user.students && user?.students.map((student) => (
                <ListItem key={student.id} onClick={handleStudentChangeReschedule(student.id)}>
                  <ListItemIcon className="student-checkbox">
                    <Checkbox
                      edge="start"
                      checked={selectedClass?.students.indexOf(student.id) !== -1}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ 'aria-labelledby': `checkbox-list-label-${student.id}` }}
                    />
                  </ListItemIcon>
                  <ListItemText className="student-items" id={`checkbox-list-label-${student.id}`} primary={student.name} />
                </ListItem>
              ))}
            </List>
          </div>
          <div className="flex">

            <Button className="cancel-class cancel-button" onClick={() => setRescheduleModal(false)} disabled={selectedSlotId === selectedClass?.id}>
              Cancel
            </Button>
            <Button className="join-class save-button" onClick={updateClass}>
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={cancelModal} onHide={() => setCancelModal(false)} dialogClassName="modal-25w">
        <Modal.Header closeButton>
          <b className="cancel-heading">Are you sure you want to cancel the class ?</b>
        </Modal.Header>
        <Modal.Body>

          <TextField id="standard-basic" className="profile-form-fields" label="Cancellation Reason" variant="standard" value={cancelReason} placeholder="Enter cancellation reason" onChange={(e) => setCancelReason(e.target.value)} />
          <Button className="join-class" onClick={cancelClass} disabled={!cancelReason}>
            Cancel Class
          </Button>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default ViewSchedule;
